export default function FormText({
  label,
  handleChange,
  value,
  name,
  type,
  ...props
}) {
  return (
    <div className="relative w-full">
      <label>{label}</label>
      <input
        required
        type={type}
        onChange={handleChange}
        value={value}
        name={name}
        placeholder={label}
        className="w-full rounded-md border border-[#ccc] py-2 px-4 font-medium placeholder:text-[#838383] focus:outline-gray-900"
        {...props}
      />
    </div>
  );
}
